import { render, staticRenderFns } from "./FancyAudioPlayer.vue?vue&type=template&id=596cd3a6&scoped=true"
import script from "./FancyAudioPlayer.vue?vue&type=script&lang=js"
export * from "./FancyAudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./FancyAudioPlayer.vue?vue&type=style&index=0&id=596cd3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596cd3a6",
  null
  
)

export default component.exports